import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';

import { API_ROOT } from '../../settings';
import { login } from '../../actions/authActions';
import Spinner from '../misc/Spinner';
import { getMailToLink } from '../../utils';

export class LoginPage extends React.Component {
  state = {
    error: '',
    loading: false
  };

  componentDidMount() {
    document.body.className = 'login';
    const myNav = navigator.userAgent.toLowerCase();
    const IE = (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
    if (IE && IE < 10) {
      alert('Your browser is not supported. Please update your browser or download Google Chrome for optimal performance.');
    }
  }

  _onSubmit = e => {
    e.preventDefault();
    const username = e.target.elements.username.value;
    const password = e.target.elements.password.value;
    const optionalUsername = e.target.elements.optionalUsername.value;
    if (username && password) {
      this.setState(() => ({
        loading: true
      }));
      axios({
        method: 'post',
        url: API_ROOT + '/api/puma/login/',
        data: { username, password, optionalUsername }
      })
        .then(response => {
          this.props.login(response.data.result);
        })
        .catch(e => {
          this.setState(() => ({
            loading: false,
            error: e.response ? e.response.data.message : e.message
          }));
        });
    } else {
      this.setState(() => ({
        error: 'Please provide your username and password.'
      }));
    }
  };

  render() {
    return <div>
      <div id="container">
        <header role="banner" id="header--puma">
          <div className="container">
            <div className="logo">
              <Link to="/">
                <img src="/assets/img/UTSouthwestern-Medical-Group.svg" alt="UTSouthwestern Medical Center" />
              </Link>
            </div>
          </div>
        </header>
        <div id="main" role="main">
          <div className="login_form">
            <form onSubmit={this._onSubmit}>
              <h1>
                <span className="cap">P</span>rofile<br />
                <span className="cap">U</span>pdate<br />
                <span className="cap">M</span>anagement<br />
                <span className="cap">A</span>dmin
                </h1>

              <label>
                <span className="visuallyhidden">Admin User ID</span>
                <input type="text" name="username" defaultValue="" placeholder="Username" autoComplete="no" autoFocus />
                {/* <input type="text" name="username" defaultValue="admin" placeholder="User ID" autoComplete="no" autoFocus /> */}
              </label>

              <label>
                <span className="visuallyhidden">Password</span>
                <input type="password" name="password" defaultValue="" placeholder="Password" autoComplete="new-password" />
              </label>

              <label>
                <span className="">Optional Login as Liaison or Provider</span>
                <input type="text" name="optionalUsername" defaultValue="" placeholder="User ID" autoComplete="no" />
              </label>

              <button className="login_submit" disabled={this.state.loading}>
                {this.state.loading ? <Spinner /> : 'Login'}
              </button>

              {this.state.error && <div className="errorMsg"><p>{this.state.error}</p></div>}
              <p>If you have trouble logging in, please email <a href={ getMailToLink('digital@utsouthwestern.edu', 'Login Page', 'Trouble Loggin In') }>digital@utsouthwestern.edu</a>.</p>
            </form>
          </div>
        </div>
      </div>
    </div>;
  }
}

const mapDispatchToProps = dispatch => ({
  login: auth => dispatch(login(auth))
});

export default connect(undefined, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.jsx